export default __webpack_public_path__ + "static/media/sliderMobile_4.080627bd.jpg";